import React from 'react';
import clsx from 'clsx';

import './style.css';

export interface SectionProps {
  id?: string;
  className?: string;
  children: React.ReactNode;
  variant?: 'light' | 'dark' | 'primary' | 'secondary' | 'light-orange' | 'white';
  padding?: 'sm' | 'md' | 'lg' | 'xl';
  background?: string;
  style?: React.CSSProperties;
}

const Section: React.FC<SectionProps> = ({
  id,
  className,
  children,
  variant = 'light',
  padding = 'lg',
  background,
  style: styleProp,
  ...props
}) => {
  const sectionClass = clsx(
    'section',
    `section-${variant}`,
    `py-${padding}`,
    className
  );

  let sectionStyle: React.CSSProperties | undefined = background ? { backgroundImage: `url(${background})` } : undefined;
  if (variant === 'light-orange') {
    sectionStyle = { backgroundColor: 'var(--orange-lpdp-light, #FFF6F5)' };
  } else if (variant === 'white') {
    sectionStyle = { backgroundColor: '#fff' };
  }
  const mergedStyle = sectionStyle || styleProp ? { ...sectionStyle, ...styleProp } : undefined;

  return (
    <section
      id={id}
      className={sectionClass}
      style={mergedStyle}
      {...props}
    >
      {children}
    </section>
  );
};

export default Section;